import styled from 'styled-components';

const ContainerWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  max-width: ${props => props.WidthSize ? props.WidthSize : '1090px'};
  margin: ${props => props.Margin ? props.Margin : 'auto'};
`;

export default ContainerWrapper;
